import React from 'react'

const CardBox = (props) => {
  const isCompact = props.compact !== false; // Default to compact
  return (
    <div class="col-md">
      <div class="card radius-10 border-start border-0 border-3 border-info" style={{ marginBottom: '0.5rem' }}>
        <div class="card-body" style={{ padding: isCompact ? '0.75rem' : '1rem' }}>
          <div class="d-flex align-items-center">
            <div style={{ flex: 1 }}>
              <p class="mb-0 text-secondary" style={{ fontSize: isCompact ? '0.75rem' : '0.875rem', marginBottom: '0.25rem' }}>
                {props.title}
              </p>
              <h2 class="my-1 text-info" style={{ fontSize: isCompact ? '1.25rem' : '1.5rem', marginTop: '0.25rem', marginBottom: '0.25rem', fontWeight: '600' }}>
                {props.value}
              </h2>
            </div>
            <div class="widgets-icons-2 rounded-circle bg-gradient-blooker text-white ms-auto" style={{ width: isCompact ? '2.5rem' : '3rem', height: isCompact ? '2.5rem' : '3rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <i class={props.icon} style={{ fontSize: isCompact ? '1rem' : '1.25rem' }}></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardBox